<template>
  <div />
</template>

<script>
import { mapState } from 'vuex'
import { hasRole } from 'utils/functions'

export default {
  name: 'preventCopyAndPasteText',
  computed: {
    ...mapState({
      loggedIn: ({ session }) => session.status.loggedIn
    })
  },
  methods: {
    hasRole (group, role) {
      return hasRole(group, role)
    },

    preventDefaultCopyPaste (e) {
      e.preventDefault()
    },

    addPreventCopyAndPasteText () {
      if (this.loggedIn && this.hasRole('ui', 'UI_DISABLE_COPY')) {
        document.addEventListener('copy', this.preventDefaultCopyPaste)
        document.addEventListener('paste', this.preventDefaultCopyPaste)
      }
    },

    removePreventCopyAndPasteText () {
      document.removeEventListener('copy', this.preventDefaultCopyPaste)
      document.removeEventListener('paste', this.preventDefaultCopyPaste)
    }
  },
  watch: {
    loggedIn (val) {
      if (val) {
        return this.addPreventCopyAndPasteText()
      }

      this.removePreventCopyAndPasteText()
    }
  },
  beforeDestroy () {
    this.removePreventCopyAndPasteText()
  },
  mounted () {
    this.addPreventCopyAndPasteText()
  }
}
</script>
